import GasTankModal from './GasTankModal'

export default GasTankModal
